<template>
    <div>
        <AttribValuesList v-if="modal.open" :product="modal.product" @close="closeModal"></AttribValuesList>
        <VariantsList v-if="variantsModal.open" :product="variantsModal.product" @close="closeVariantsModal"></VariantsList>
        <nav class="hidden md:flex mb-4 h-8" aria-label="Breadcrumb">
            <ol role="list" class="flex space-x-4 rounded-md bg-white px-6 shadow">
            <li class="flex">
                <div class="flex items-center">
                <router-link to="/hub" class="transition ease-in-out duration-300 text-gray-400 hover:text-gray-500">
                    <HomeIcon class="h-5 w-5 flex-shrink-0" aria-hidden="true" />
                    <span class="sr-only">Home</span>
                </router-link>
                </div>
            </li>
            <li class="flex">
                <div class="flex items-center">
                <svg class="h-full w-6 flex-shrink-0 text-gray-200" viewBox="0 0 24 44" preserveAspectRatio="none" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
                </svg>
                <router-link to="/dashboard/products" class="transition ease-in-out duration-300 ml-4 text-xs font-medium text-gray-500 hover:text-gray-700" aria-current="page">Moduł produkty</router-link>
                </div>
            </li>
            <li class="flex">
                <div class="flex items-center">
                <svg class="h-full w-6 flex-shrink-0 text-gray-200" viewBox="0 0 24 44" preserveAspectRatio="none" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
                </svg>
                <div class="ml-4 text-xs font-medium text-gray-400 cursor-default" aria-current="page">Lista produktów</div>
                </div>
            </li>
            </ol>
        </nav>
        <router-link to="/dashboard/products" class="block md:hidden transition ease-in-out duration-300 mb-2 text-sm font-medium text-blue-500 hover:text-blue-700" aria-current="page">&larr; Cofnij</router-link>

        <div v-if="brokenPackagesTable && brokenPackagesTable.length > 0" class="mb-6">
            <h2 class="text-lg font-semibold mb-2">Zepsute paczki</h2>
            <div class="overflow-x-auto">
                <table class="min-w-full divide-y divide-gray-300 bg-white rounded shadow">
                    <thead class="bg-gray-100">
                        <tr>
                            <th class="px-3 py-2 text-left text-xs font-medium text-gray-700">Produkt</th>
                            <th class="px-3 py-2 text-left text-xs font-medium text-gray-700">Wariant</th>
                            <th class="px-3 py-2 text-left text-xs font-medium text-gray-700">Stara nazwa paczki</th>
                            <th class="px-3 py-2 text-left text-xs font-medium text-gray-700">Nowa nazwa paczki</th>
                            <th class="px-3 py-2 text-left text-xs font-medium text-gray-700">Magazyn</th>
                            <th class="px-3 py-2 text-left text-xs font-medium text-gray-700">Segment</th>
                            <th class="px-3 py-2 text-left text-xs font-medium text-gray-700">Akcja</th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-gray-200">
                        <tr v-for="row in brokenPackagesTable" :key="`${row.productId}_${row.variantId}_${row.oldPackageName}_${row.segmentId}`">
                            <td class="px-3 py-2 text-xs text-gray-900">{{ row.productName }}<br><span class="text-gray-400">({{ row.productId }})</span></td>
                            <td class="px-3 py-2 text-xs text-gray-900">{{ row.variantName }}<br><span class="text-gray-400">({{ row.variantId }})</span></td>
                            <td class="px-3 py-2 text-xs text-gray-900">{{ row.oldPackageName }}</td>
                            <td class="px-3 py-2">
                                <input v-model="row.newPackageName" :disabled="row.updating || row.updated" type="text" class="border border-gray-300 rounded px-2 py-1 text-xs w-32" placeholder="Nowa nazwa" />
                            </td>
                            <td class="px-3 py-2 text-xs text-gray-900">{{ row.storageId }}</td>
                            <td class="px-3 py-2 text-xs text-gray-900">{{ row.segmentId }}</td>
                            <td class="px-3 py-2">
                                <button
                                    class="transition ease-in-out duration-300 inline-flex items-center px-2 py-1 rounded bg-green-100 text-green-700 text-xs font-medium hover:bg-green-200 disabled:opacity-50"
                                    :disabled="!row.newPackageName || row.updating || row.updated"
                                    @click="fixBrokenPackage(row)"
                                >
                                    <span v-if="row.updating">Aktualizuję...</span>
                                    <span v-else-if="row.updated">Zmieniono</span>
                                    <span v-else>Zmień</span>
                                </button>
                                <div v-if="row.error" class="text-xs text-red-500 mt-1">{{ row.error }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        
        <div v-if="productsWithSpacesTable && productsWithSpacesTable.length > 0" class="mb-6">
            <h2 class="text-lg font-semibold mb-2">Produkty z parts[n].name ze spacją</h2>
            <button @click="updateAllPartsNames" class="inline-flex items-center px-2 py-1 rounded bg-blue-100 text-blue-700 text-xs font-medium hover:bg-blue-200">Zaktualizuj wszystkie</button>
            <div class="overflow-x-auto">
            <table class="min-w-full divide-y divide-gray-300 bg-white rounded shadow">
            <thead class="bg-gray-100">
            <tr>
                <th class="px-3 py-2 text-left text-xs font-medium text-gray-700">Produkt</th>
                <th class="px-3 py-2 text-left text-xs font-medium text-gray-700">Wariant</th>
                <th class="px-3 py-2 text-left text-xs font-medium text-gray-700">Nazwa parta</th>
                <th class="px-3 py-2 text-left text-xs font-medium text-gray-700">Nowa nazwa</th>
                <th class="px-3 py-2 text-left text-xs font-medium text-gray-700">Akcja</th>
                <th class="px-3 py-2 text-left text-xs font-medium text-gray-700">Segmenty</th>
            </tr>
            </thead>
            <tbody class="divide-y divide-gray-200">
            <tr v-for="row in productsWithSpacesTable" :key="`${row.productId}_${row.variantId}_${row.partName}`">
                <td class="px-3 py-2 text-xs text-gray-900">{{ row.productName }}<br><span class="text-gray-400">({{ row.productId }})</span></td>
                <td class="px-3 py-2 text-xs text-gray-900">{{ row.variantName }}<br><span class="text-gray-400">({{ row.variantId }})</span></td>
                <td class="px-3 py-2 text-xs text-gray-900">{{ row.partName }}</td>
                <td class="px-3 py-2">
                <input v-model="row.newPartName" :disabled="row.updating || row.updated" type="text" class="border border-gray-300 rounded px-2 py-1 text-xs w-32" placeholder="Nowa nazwa" />
                </td>
                <td class="px-3 py-2">
                <button
                class="transition ease-in-out duration-300 inline-flex items-center px-2 py-1 rounded bg-green-100 text-green-700 text-xs font-medium hover:bg-green-200 disabled:opacity-50"
                :disabled="!row.newPartName || row.updating || row.updated"
                @click="updatePartName(row)"
                >
                <span v-if="row.updating">Aktualizuję...</span>
                <span v-else-if="row.updated">Zmieniono</span>
                <span v-else>Zmień</span>
                </button>
                <div v-if="row.error" class="text-xs text-red-500 mt-1">{{ row.error }}</div>
                </td>
                <td class="px-3 py-2 text-xs text-gray-900">
                <div v-if="row.segments && row.segments.length > 0">
                    <div v-for="seg in row.segments" :key="`${seg.storageId}_${seg.segmentId}`">
                    Magazyn: <span class="font-semibold">{{ seg.storageId }}</span>, Segment: <span class="font-semibold">{{ seg.segmentId }}</span>
                    </div>
                </div>
                <div v-else>
                    <span class="text-gray-400">Brak powiązanych segmentów</span>
                </div>
                </td>
            </tr>
            </tbody>
            </table>
            </div>
        </div>

        <div v-if="brokenVariantPartsTable && brokenVariantPartsTable.length > 0" class="mb-6">
            <div class="mb-2 flex flex-wrap items-center gap-3">
                <h2 class="text-lg font-semibold">Zepsute parts w wariantach</h2>
                <button
                    class="transition ease-in-out duration-300 inline-flex items-center px-2 py-1 rounded bg-green-100 text-green-700 text-xs font-medium hover:bg-green-200 disabled:opacity-50"
                    :disabled="repairingBrokenVariantParts || brokenVariantPartsTable.filter(row => row.repairable && !row.updated).length === 0"
                    @click="repairAllBrokenVariantParts()"
                >
                    <span v-if="repairingBrokenVariantParts">Naprawiam masowo...</span>
                    <span v-else>Napraw wszystkie możliwe ({{ brokenVariantPartsTable.filter(row => row.repairable && !row.updated).length }})</span>
                </button>
            </div>
            <div class="overflow-x-auto">
                <table class="min-w-full divide-y divide-gray-300 bg-white rounded shadow">
                    <thead class="bg-gray-100">
                        <tr>
                            <th class="px-3 py-2 text-left text-xs font-medium text-gray-700">Produkt</th>
                            <th class="px-3 py-2 text-left text-xs font-medium text-gray-700">Wariant</th>
                            <th class="px-3 py-2 text-left text-xs font-medium text-gray-700">Part key</th>
                            <th class="px-3 py-2 text-left text-xs font-medium text-gray-700">Problem</th>
                            <th class="px-3 py-2 text-left text-xs font-medium text-gray-700">Oczekiwane</th>
                            <th class="px-3 py-2 text-left text-xs font-medium text-gray-700">Akcja</th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-gray-200">
                        <tr v-for="row in brokenVariantPartsTable" :key="`${row.productId}_${row.variantId}_${row.partKey}_${row.issue}`">
                            <td class="px-3 py-2 text-xs text-gray-900">{{ row.productName }}<br><span class="text-gray-400">({{ row.productId }})</span></td>
                            <td class="px-3 py-2 text-xs text-gray-900">{{ row.variantName }}<br><span class="text-gray-400">({{ row.variantId }})</span></td>
                            <td class="px-3 py-2 text-xs font-mono text-gray-900">{{ row.partKey }}</td>
                            <td class="px-3 py-2 text-xs text-red-700">{{ row.issue }}</td>
                            <td class="px-3 py-2 text-xs text-gray-700">{{ row.expected }}</td>
                            <td class="px-3 py-2">
                                <button
                                    class="transition ease-in-out duration-300 inline-flex items-center px-2 py-1 rounded bg-green-100 text-green-700 text-xs font-medium hover:bg-green-200 disabled:opacity-50"
                                    :disabled="!row.repairable || row.updating || row.updated"
                                    @click="repairBrokenVariantPart(row)"
                                >
                                    <span v-if="row.updating">Naprawiam...</span>
                                    <span v-else-if="row.updated">Naprawiono</span>
                                    <span v-else>Napraw</span>
                                </button>
                                <div v-if="!row.repairable" class="text-xs text-gray-400 mt-1">Tylko raport</div>
                                <div v-if="row.error" class="text-xs text-red-500 mt-1">{{ row.error }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- <label for="search" class="block text-sm font-medium text-gray-700 mt-4">Search</label> -->
        <!-- <button @click.prevent="repairNulls">TEST</button> -->
        <!-- SEARCHER -->
        <div class="min-w-0 flex-1 xl:col-span-6">
            <div class="flex items-center justify-between">
                <div class="w-2/3 sm:w-1/3 flex">
                    <label for="search" class="sr-only">Szukaj</label>
                    <div class="relative">
                        <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                            <SearchIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
                        </div>
                        <input :disabled="this.searcher.locked" v-model="searcher.phrase" id="search" name="search" :class="['block w-full rounded-md border border-gray-300 bg-white py-2 pl-10 pr-3 text-sm placeholder-gray-500 focus:border-blue-500 focus:text-gray-900 focus:placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-blue-500 sm:text-sm', this.searcher.locked ? 'opacity-50' : '']" placeholder="Wyszukaj" type="search" />
                    </div>
                    <button :disabled="this.searcher.locked" type="button" @click.prevent="search" :class="['transition ease-in-out duration-300 ml-2 inline-flex items-center rounded border border-transparent bg-blue-100 px-2.5 py-1.5 text-xs font-medium text-blue-700', this.searcher.locked || this.searcher.phrase.length === 0 ? 'opacity-50 cursor-default' : 'hover:bg-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2']">Szukaj</button>
                </div>
                <div class="flex items-center justify-center">
                    <router-link to="/dashboard/products/add" type="button"  class="transition ease-in-out duration-300 inline-flex items-center p-2 border border-transparent rounded-full shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                        <PlusSmIcon class="h-6 w-6" aria-hidden="true" />
                    </router-link>
                    <div class="flex gap-2 flex-col ml-4" v-if="showAdminDiagnostics">
                        <span class="inline-flex items-center rounded-md bg-purple-50 px-2 py-1 text-xs font-medium text-purple-700 border border-purple-700/10 hover:opacity-70 cursor-pointer" @click="findProductsWithSpaceInPartsName()">Znajdz paczki /w special characters</span>
                        <span class="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 border border-red-700/10 hover:opacity-70 cursor-pointer" @click="findBrokenPackages()">Znajdz paczki zepsute na magazyn</span>
                        <span class="inline-flex items-center rounded-md bg-orange-50 px-2 py-1 text-xs font-medium text-orange-700 border border-red-700/10 hover:opacity-70 cursor-pointer" @click="logMismatchedIdsVsQuantityWithNames()">Znajdz paczki ids.length != quantity</span>
                        <span class="inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-700 border border-yellow-700/10 hover:opacity-70 cursor-pointer" @click="findBrokenVariantParts()">Znajdz zepsute parts w wariantach</span>
                    </div>
                </div>
            </div>
            <div class="mt-4" v-if="searcher.found.length > 0">
                <span class="inline-flex items-center py-0.5 pl-2 pr-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-700">
                    Wynik wyszukiwania dla frazy: "{{searcher.lastCall.phrase}}" (Znaleziono: {{searcher.found.length}})
                    <button @click.prevent="resetSearch"  type="button" class="transition ease-in-out duration-300 flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center text-blue-400 hover:bg-blue-200 hover:text-blue-500 focus:outline-none focus:bg-blue-500 focus:text-white">
                        <svg class="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
                            <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7" />
                        </svg>
                    </button>
                </span>           
            </div>
        </div>
        <!-- <Spinner v-if="loading"></Spinner> -->
        <div class="mt-4 flex flex-col pl-2 pr-4 sm:pl-0 sm:pr-6 xl:px-0">
            <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="inline-block min-w-full py-2 align-middle sm:px-6 pl-2 pr-0.5 lg:px-8">
                    <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 rounded-lg" v-if="!loading">
                        <table class="min-w-full divide-y divide-gray-300">
                            <thead class="bg-gray-50">
                                <tr>
                                <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">Produkt</th>
                                <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900"><span class="sr-only">Kupione</span></th>
                                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">EAN / SKU</th>
                                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Atrybuty</th>
                                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Warianty</th>
                                <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                                    <span class="sr-only">Edycja</span>
                                </th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 bg-white">
                                <tr v-for="product in searcher.found.length > 0 ? searcher.found : products" :key="product.id">
                                    <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm sm:pl-6">
                                        <div class="flex items-center">
                                        <div class="h-10 w-10 flex-shrink-0">
                                            <img class="h-10 w-10 rounded-md object-contain" :src="product.image.url.length>0 ? product.image.url : `https://api.dicebear.com/7.x/initials/svg?seed=${`Product${product.id}`}`" :alt="product.name" />
                                        </div>
                                        <div class="ml-4">
                                            <div class="font-medium text-gray-900">{{product.name}} <span class="transition ease-in-out duration-300 text-xs text-blue-300 hover:text-blue-500 select-none cursor-pointer" @click.prevent="copyToClipboard(product.id)">Kopiuj ID</span><span @click="generateCustomIds(product)" class="text-xs ml-2 text-gray-200 hover:text-gray-500 transiiton-all duration-300 cursor-pointer">generuj</span></div>
                                            <div class="text-gray-500"><span class="text-xs" v-if="product.category.name.length>0">{{product.category.name}} <span class="text-xs opacity-60">(ID kategorii:{{product.category.id}})</span></span><span class="text-xs" v-if="product.category.name.length===0">Brak kategorii</span></div>
                                        </div>
                                        </div>
                                    </td>
                                    <td>
                                        <span  @click="showVariantsModal(product)" v-if="product.ordered" class="transition ease-in-out duration-300 select-none w-fit inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium bg-green-50 text-green-400 cursor-pointer hover:bg-green-100 hover:text-green-600">Zamówione</span>
                                        
                                    </td>
                                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 select-none">
                                        <div class="text-gray-500"><span class="text-xs" v-if="product.ean.length>0"><span class="text-gray-700 font-medium">EAN: </span>{{product.ean}}</span><span class="text-xs font-medium opacity-60" v-if="product.ean.length===0">Brak EAN</span><span class="transition ease-in-out duration-300 ml-2 text-xs text-blue-300 hover:text-blue-600 select-none cursor-pointer" v-if="product.ean.length>0" @click.prevent="copyToClipboard(product.ean)">Kopiuj</span></div>
                                        <div class="text-gray-500"><span class="text-xs" v-if="product.sku.length>0"><span class="text-gray-700 font-medium">SKU: </span>{{product.sku}}</span><span class="text-xs font-medium opacity-60" v-if="product.sku.length===0">Brak SKU</span><span class="transition ease-in-out duration-300 ml-2 text-xs text-blue-300 hover:text-blue-600 select-none cursor-pointer" v-if="product.sku.length>0" @click.prevent="copyToClipboard(product.sku)">Kopiuj</span></div>
                                    </td>
                                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 select-none">
                                        <div>
                                            <span v-for="value in product.attribs.list.slice(0, 1)" :key="value.id" @click="showModal(product)"  class="transition ease-in-out duration-300 select-none w-fit inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium bg-gray-100 text-gray-600 cursor-pointer hover:bg-blue-100 hover:text-blue-400"> {{value.parent.name}}: {{value.name}} </span>
                                            <span class="transition ease-in-out duration-300 text-xs px-2.5 py-0.5 text-blue-300 hover:text-blue-500 cursor-pointer" v-if="product.attribs.list.length-1 > 0" @click="showModal(product)">+ {{product.attribs.list.length-1}} więcej</span>
                                            <span class="text-xs" v-if="product.attribs.list.length === 0">Brak atrybutów</span>
                                        </div>
                                    </td>
                                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-700 select-none">
                                        <div>
                                            <!-- <span v-for="value in product.attribs.list.slice(0, 1)" :key="value.id" @click="showModal(product)"  class="transition ease-in-out duration-300 select-none w-fit inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium bg-gray-100 text-gray-600 cursor-pointer hover:bg-blue-100 hover:text-blue-400"> {{value.parent.name}}: {{value.name}} </span> -->
                                            <span class="transition ease-in-out duration-300 select-none w-fit inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium bg-blue-50 text-blue-400 cursor-pointer hover:bg-blue-100 hover:text-blue-600" v-if="Object.keys(product.variants).length > 0" @click="showVariantsModal(product)">{{Object.keys(product.variants).length}} {{Object.keys(product.variants).length === 1 ? "wariant" : Object.keys(product.variants).length > 1 && Object.keys(product.variants).length < 5 ? "warianty" : "wariantów"}}</span>
                                            <span class="text-xs" v-if="Object.keys(product.variants).length === 0">Brak wariantów</span>
                                        </div>
                                    </td>
                                    <!-- <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 select-none"> -->
                                        <!-- <span class="inline-flex rounded-full bg-green-100 px-2 text-xs font-semibold leading-5 text-green-800" v-if="product.active">Aktywny</span>
                                        <span class="inline-flex rounded-full bg-red-100 px-2 text-xs font-semibold leading-5 text-red-800" v-if="!product.active">Nieaktywny</span> -->
                                    <!-- </td> -->
                                    <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                        <router-link :to="`/dashboard/products/list/editProduct?id=${product.id}`" target="_blank" class="transition ease-in-out duration-300 text-blue-600 hover:text-blue-900"
                                        >
                                        <div class="transition ease-in-out duration-300 relative inline-flex items-center px-4 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500">Edytuj</div>
                                        <span class="sr-only">, {{ product.name }}</span></router-link>
                                        <router-link :to="`/dashboard/products/list/viewProduct?id=${product.id}`" target="_blank" class="text-blue-600 hover:text-blue-900"
                                        >
                                        <div type="button" class="transition ease-in-out duration-300 -ml-px relative inline-flex items-center px-4 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500">Zobacz</div>
                                        <span class="sr-only">, {{ product.name }}</span></router-link>                                                      
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <EmptyState class="mt-2 mb-2" v-if="products.length === 0"></EmptyState>
        <div class="flex items-center justify-center mt-4" v-if="queryLimitReached === false">
            <button type="button" @click.prevent="loadMoreProducts" class="transition ease-in-out duration-300 inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">Załaduj więcej..</button>
        </div>    
    </div>
</template>

<script>
    // import Spinner  from '@/components/loadingSpinner.vue';
    import AttribValuesList from "@/components/ActualAttribsInProductModal.vue";
    import VariantsList from "@/components/ActualVariantsInProductModal.vue";
    import {db} from "@/firebase/gfbconf.js";
    import firebase from "firebase/app";
    import "firebase/firestore";
    import { FieldValue } from 'firebase/firestore';
    import axios from 'axios';
    import randomstring from 'randomstring';
    import EmptyState from '../components/EmptyState.vue';
    import { SearchIcon, PlusSmIcon, XIcon  } from '@heroicons/vue/outline';
    import { HomeIcon  } from '@heroicons/vue/solid';
    export default {
        name: "ProductList",
        data()
        {
            return {
                newPackageName: '',
                oldPackageName: '',
                variantId: '',
                productId: '',
                segmentId: '',
                storageId: '',
                loading: false,
                brokenPackagesTable: [], // <-- ensure reactivity
                productsWithSpacesTable: [], // <-- ensure reactivity
                brokenVariantPartsTable: [],
                repairingBrokenVariantParts: false,
                modal: {
                    open: false,
                    product: null,
                },
                variantsModal: {
                    open: false,
                    product: null,
                },
                searcher: {
                    found: [],
                    locked: false,
                    phrase: "",
                    lastCall: null
                },
                products: [],
                queryLimit: 25,
                dbListener: null,
                lastLoaded: null,
                queryLimitReached: false,
            }
        },
        components: { SearchIcon, PlusSmIcon, XIcon, HomeIcon, AttribValuesList, VariantsList, EmptyState },
        async created()
        {
            if (!this.$store.state.userData.permissions.admin && !this.$store.state.userData.permissions.products) {
                this.$router.push("/hub")
            }
            await this.getProducts()
        },
        beforeUnmount() {
            if (this.dbListener !== null) {
                this.dbListener();
            }
        },
        computed:
        {
            showAdminDiagnostics()
            {
                return !!this.$store.state.userData.permissions.admin && this.$route.query.admin === 'yes';
            }
        },
        methods:
        {
            async updatePartName(row) {
                row.updating = true;
                row.error = null;
                console.log(row);
                try {
                const res = await axios.post(`${this.$store.state.apiLink}/updatePartName`, {
                    productId: row.productId,
                    variantId: row.variantId,
                    partId: row.partId, // dodaj partId
                    oldPartName: row.partName,
                    newPartName: row.newPartName
                });
                if (res.data && res.data.success) {
                    row.updated = true;
                    this.$store.commit('setNotification', {
                    show: true,
                    head: "Zaktualizowano nazwę parta!",
                    subheader: `Nowa nazwa: ${row.newPartName}`,
                    success: true
                    });
                } else {
                    throw new Error(res.data && res.data.message ? res.data.message : 'Błąd podczas aktualizacji parta!');
                }
                } catch (error) {
                row.error = error.message || error;
                this.$store.commit('setNotification', {
                    show: true,
                    head: "Błąd podczas aktualizacji parta!",
                    subheader: error.message || error,
                    success: false
                });
                }
                row.updating = false;
            },
        
            async findBrokenPackages() {
            try {
                this.brokenPackagesTable = [];
                this.loading = true;

                // 1) pobierz produkty
                const getAllProducts = async () => {
                const snap = await db.collection("Products").get();
                return snap.docs.map(d => d.data());
                };
                const products = await getAllProducts();

                // 2) zbuduj mapy pomocnicze + SET poprawnych kluczy
                // correctKey = `${variantId}_${part.name}`
                const correctKeys = new Set();

                // mapowanie variantId -> dane (do ładnego wyświetlenia)
                const variantIndex = new Map(); // variantId -> { productId, productName, variantName }

                for (const prod of products) {
                const variants = Object.values(prod.variants || {});
                for (const v of variants) {
                    variantIndex.set(v.id, {
                    productId: prod.id,
                    productName: prod.name,
                    variantName: v.name,
                    });

                    const parts = Object.values(v.parts || {});
                    for (const part of parts) {
                    if (part?.name === '123' || /\s/.test(part.name)) {
                        correctKeys.add(`${v.id}_${part.name}`);
                    }
                    }
                }
                }

                // 3) pobierz segmenty magazynu (raz)
                const allSegments = [];
                const storageDocs = await db.collection("Storage").get();

                for (const storageDoc of storageDocs.docs) {
                const segSnap = await db
                    .collection("Storage")
                    .doc(storageDoc.id)
                    .collection("Segments")
                    .get();

                for (const segmentDoc of segSnap.docs) {
                    const segment = segmentDoc.data();
                    segment._storageId = storageDoc.id;
                    segment._segmentId = segmentDoc.id; // <- ważne
                    allSegments.push(segment);
                }
                }

                // 4) przejdź po WSZYSTKICH kluczach w magazynie i sprawdź czy są poprawne
                for (const segment of allSegments) {
                const productsMap = segment.products || {};
                const storageId = segment._storageId;
                const segmentId = segment._segmentId;

                for (const productId of Object.keys(productsMap)) {
                    const prodMap = productsMap[productId] || {};

                    for (const k of Object.keys(prodMap)) {
                    // jeśli klucz nie jest poprawnym searchKey -> zepsuty
                    if (!correctKeys.has(k)) {
                        // spróbuj wyciągnąć variantId (zakładam format zaczyna się od v_<id>...)
                        // variantId = pierwsze dwa człony split('_'): "v" + "<id>" -> "v_<id>"
                        const parts = k.split("_");
                        const variantId = parts.length >= 2 ? `${parts[0]}_${parts[1]}_${parts[2]}_${parts[3]}` : null;

                        const meta = variantId ? variantIndex.get(variantId) : null;
                        this.brokenPackagesTable.push({
                        productId: meta?.productId || productId,
                        productName: meta?.productName || "(nieznany produkt)",
                        variantId: variantId || "(nieznany variant)",
                        variantName: meta?.variantName || "(nieznany wariant)",
                        oldPackageName: parts[4],              // <- zepsuty klucz z magazynu
                        expectedPackageKey: "",         // opcjonalnie: możesz tu zostawić puste
                        storageId,
                        segmentId,
                        segmentObj: segment,
                        newPackageName: "",
                        updating: false,
                        updated: false,
                        error: null,
                        });
                    }
                    }
                }
                }

                this.loading = false;

                if (this.brokenPackagesTable.length === 0) {
                this.$store.commit("setNotification", {
                    show: true,
                    head: "Brak zepsutych paczek!",
                    subheader: "",
                    success: true,
                });
                }
            } catch (error) {
                this.loading = false;
                console.log(error);
                this.$store.commit("setNotification", {
                show: true,
                head: "Błąd podczas wyszukiwania!",
                subheader: error.message || error,
                success: false,
                });
            }
            },

            async logMismatchedIdsVsQuantityWithNames() {
            try {
                // 1) Wczytaj wszystkie produkty
                const productsMap = {};
                try {
                const productsSnap = await db.collection('Products').get();
                for (const doc of productsSnap.docs) {
                    const data = doc.data() || {};
                    const variantsRaw = data.variants || {};
                    const variantsById = {};

                    if (Array.isArray(variantsRaw)) {
                    for (const v of variantsRaw) {
                        if (v && v.id) variantsById[v.id] = v;
                    }
                    } else if (variantsRaw && typeof variantsRaw === 'object') {
                    for (const [k, v] of Object.entries(variantsRaw)) {
                        if (v && typeof v === 'object') {
                        variantsById[v.id || k] = { id: v.id || k, ...v };
                        }
                    }
                    }

                    productsMap[doc.id] = {
                    name: data.name || '',
                    variantsById
                    };
                }
                } catch (e) {
                console.warn('Nie udało się wczytać Products:', e);
                }

                // Pomocnik: nazwa wariantu
                function resolveVariantName(productId, variantKey) {
                const meta = productsMap[productId];
                if (!meta) return '';
                const { variantsById } = meta;
                if (!variantsById) return '';

                if (variantsById[variantKey]?.name) return variantsById[variantKey].name;

                const parts = String(variantKey).split('_');
                for (let cut = parts.length - 1; cut > 0; cut--) {
                    const candidate = parts.slice(0, cut).join('_');
                    if (variantsById[candidate]?.name) return variantsById[candidate].name;
                }

                return '';
                }

                // CSV helpers
                const csvEscape = (val) => {
                const s = String(val ?? '');
                const needsQuotes = /[",\n\r]/.test(s);
                const escaped = s.replace(/"/g, '""');
                return needsQuotes ? `"${escaped}"` : escaped;
                };

                const rows = [];
                rows.push([
                'segmentName',
                'segmentId',
                'productId',
                'productName',
                'variantKey',
                'variantName',
                'quantity',
                'idsLen'
                ].join(','));

                // 2) Segmenty i rozjazdy
                const storageSnap = await db.collection('Storage').get();
                let mismatches = 0;

                for (const storageDoc of storageSnap.docs) {
                const segmentsSnap = await db
                    .collection('Storage')
                    .doc(storageDoc.id)
                    .collection('Segments')
                    .get();

                for (const segDoc of segmentsSnap.docs) {
                    const segment = segDoc.data() || {};
                    const productsMapInSeg = segment.products || {};
                    const segmentName = segment.name || '-';

                    for (const [productId, variantsMap] of Object.entries(productsMapInSeg)) {
                    if (!variantsMap || typeof variantsMap !== 'object') continue;

                    const productName = productsMap[productId]?.name || productId;

                    for (const [variantKey, variantEntry] of Object.entries(variantsMap)) {
                        if (!variantEntry || typeof variantEntry !== 'object') continue;

                        const idsLen = Array.isArray(variantEntry.ids) ? variantEntry.ids.length : 0;
                        const qRaw = variantEntry.quantity;
                        const quantity = typeof qRaw === 'number' ? qRaw : parseInt(qRaw, 10) || 0;

                        if (idsLen !== quantity) {
                        mismatches++;
                        const variantName = resolveVariantName(productId, variantKey) || '(nieznany wariant)';

                        rows.push([
                            csvEscape(segmentName),
                            csvEscape(segDoc.id),
                            csvEscape(productId),
                            csvEscape(productName),
                            csvEscape(variantKey),
                            csvEscape(variantName),
                            quantity,
                            idsLen
                        ].join(','));
                        }
                    }
                    }
                }
                }

                const csvContent = rows.join('\n');

                if (mismatches === 0) {
                alert('Brak rozjazdów ids vs quantity w segmentach.');
                return;
                }

                // 3) Pobierz CSV jako plik
                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                const dateStr = new Date().toISOString().slice(0, 10);
                a.download = `mismatches_${dateStr}.csv`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);

                console.log(`Znaleziono ${mismatches} rozjazdów ids vs quantity. CSV pobrano.`);
            } catch (e) {
                console.error('Błąd podczas generowania CSV:', e?.message || e);
                alert('Błąd podczas generowania CSV: ' + (e?.message || e));
            }
            },
            async findProductsWithSpaceInPartsName() {
                try {
                    this.loading = true;
                    const productsWithSpaces = [];
                    const getProducts = await db.collection('Products').get();

                    // Pobierz wszystkie segmenty tylko raz na początku
                    const allSegments = [];
                    const storageDocs = await db.collection('Storage').get();
                    for (let s = 0; s < storageDocs.docs.length; s++) {
                        const storage = storageDocs.docs[s];
                        const segments = await db.collection('Storage').doc(storage.id).collection('Segments').get();
                        for (let seg = 0; seg < segments.docs.length; seg++) {
                            const segment = segments.docs[seg].data();
                            segment._storageId = storage.id;
                            segment._segmentId = segment.id;
                            allSegments.push(segment);
                        }
                    }

                    for (let i = 0; i < getProducts.docs.length; i++) {
                        const prod = getProducts.docs[i].data();
                        const variants = Object.values(prod.variants || {});
                        for (let y = 0; y < variants.length; y++) {
                            const partsEntries = Object.entries(variants[y].parts || {});
                            for (let p = 0; p < partsEntries.length; p++) {
                                const [partId, part] = partsEntries[p];
                                // Sprawdź, czy part.name zawiera jakikolwiek biały znak (spacja, tab itp.)
                                if (part.name === '123' || /\s/.test(part.name)) {
                                    const searchKey = `${variants[y].id}_${part.name}`;
                                    const segmentsWithPackage = allSegments.filter(segment =>
                                        segment.products &&
                                        segment.products[prod.id] &&
                                        Object.keys(segment.products[prod.id]).some(k => k === searchKey)
                                    ).map(segment => ({
                                        storageId: segment._storageId,
                                        segmentId: segment._segmentId,
                                        segmentObj: segment
                                    }));

                                    productsWithSpaces.push({
                                        productId: prod.id,
                                        productName: prod.name,
                                        variantId: variants[y].id,
                                        variantName: variants[y].name,
                                        partId: partId,
                                        partName: part.name,
                                        newPartName: partId, // Dodaj od razu newPartName
                                        hasPackageOnSegment: segmentsWithPackage.length > 0,
                                        segments: segmentsWithPackage,
                                        updating: false,
                                        updated: false,
                                        error: null
                                    });
                                }
                            }
                        }
                    }
                    this.loading = false;
                    this.productsWithSpacesTable = productsWithSpaces;
                    if (productsWithSpaces.length === 0) {
                        this.$store.commit('setNotification', {
                            show: true,
                            head: "Brak produktów z parts[n].name ze spacją!",
                            subheader: "",
                            success: true
                        });
                    }
                } catch (error) {
                    this.loading = false;
                    console.log(error);
                    this.$store.commit('setNotification', {
                        show: true,
                        head: "Błąd podczas wyszukiwania!",
                        subheader: error.message || error,
                        success: false
                    });
                }
            },
            async findBrokenVariantParts() {
                try {
                    this.loading = true;
                    this.brokenVariantPartsTable = [];

                    const brokenParts = [];
                    const productsSnapshot = await db.collection('Products').get();

                    const addIssue = (product, variantKey, variant, partKey, issue, expected, repairType = null) => {
                        brokenParts.push({
                            productDocId: product._docId || product.id || '',
                            productId: product.id || product._docId || '',
                            productName: product.name || '',
                            variantKey,
                            variantId: variant?.id || variantKey || '',
                            variantName: variant?.name || '',
                            partKey: partKey === undefined || partKey === null ? '---' : String(partKey),
                            issue,
                            expected,
                            repairType,
                            repairable: repairType !== null,
                            updating: false,
                            updated: false,
                            error: null,
                        });
                    };

                    for (const productDoc of productsSnapshot.docs) {
                        const product = productDoc.data() || {};
                        product._docId = productDoc.id;
                        const variantsEntries = Object.entries(product.variants || {});

                        for (const [variantKey, variant] of variantsEntries) {
                            if (!variant || typeof variant !== 'object') {
                                addIssue(product, variantKey, variant, variantKey, 'Wariant nie jest poprawnym obiektem.', 'variants.<variantId> jako obiekt');
                                continue;
                            }

                            const parts = variant.parts;
                            if (parts === null || parts === undefined) {
                                continue;
                            }

                            if (typeof parts !== 'object' || Array.isArray(parts)) {
                                addIssue(product, variantKey, variant, 'parts', 'Pole parts nie jest mapą/obiektem.', 'parts jako obiekt z kluczami 1..amountOfPackages albo null');
                                continue;
                            }

                            const amountOfPackages = Number(variant.amountOfPackages || 0);
                            const expectedKeys = amountOfPackages > 0
                                ? Array.from({ length: amountOfPackages }, (item, index) => String(index + 1))
                                : [];
                            const expectedKeysSet = new Set(expectedKeys);
                            const partEntries = Object.entries(parts);

                            if (partEntries.length === 0) {
                                addIssue(product, variantKey, variant, 'parts', 'parts jest pustym obiektem {}.', expectedKeys.length > 0 ? `oczekiwane klucze: ${expectedKeys.join(', ')}` : 'parts jako null albo obiekt z paczkami', 'emptyPartsObject');
                                continue;
                            }

                            const existingKeysSet = new Set(partEntries.map(([partKey]) => String(partKey)));

                            for (const expectedKey of expectedKeys) {
                                if (!existingKeysSet.has(expectedKey)) {
                                    addIssue(product, variantKey, variant, expectedKey, 'Brakuje oczekiwanego parta.', expectedKeys.join(', '));
                                }
                            }

                            for (const [partKey, part] of partEntries) {
                                const normalizedKey = String(partKey);

                                if (normalizedKey === 'null' || normalizedKey === 'undefined' || normalizedKey.trim().length === 0) {
                                    addIssue(product, variantKey, variant, normalizedKey, 'Niepoprawny klucz parta.', expectedKeys.length > 0 ? expectedKeys.join(', ') : 'klucz numeryczny 1..N', 'invalidPartKey');
                                    continue;
                                }

                                if (expectedKeys.length > 0 && !expectedKeysSet.has(normalizedKey)) {
                                    addIssue(product, variantKey, variant, normalizedKey, 'Nadmiarowy part poza amountOfPackages.', expectedKeys.join(', '));
                                }

                                if (part === null || part === undefined) {
                                    addIssue(product, variantKey, variant, normalizedKey, 'Part ma wartość null/undefined.', 'part jako obiekt');
                                    continue;
                                }

                                if (typeof part !== 'object' || Array.isArray(part)) {
                                    addIssue(product, variantKey, variant, normalizedKey, 'Part nie jest poprawnym obiektem.', 'part jako obiekt');
                                    continue;
                                }

                                if (Object.keys(part).length === 0) {
                                    addIssue(product, variantKey, variant, normalizedKey, 'Part jest pustym obiektem.', 'part z danymi paczki');
                                }
                            }
                        }
                    }

                    this.brokenVariantPartsTable = brokenParts;

                    if (brokenParts.length === 0) {
                        this.$store.commit('setNotification', {
                            show: true,
                            head: "Nie znaleziono zepsutych parts w wariantach.",
                            subheader: "",
                            success: true
                        });
                    } else {
                        this.$store.commit('setNotification', {
                            show: true,
                            head: `Znaleziono ${brokenParts.length} problemów w parts.`,
                            subheader: "Raport pojawił się nad listą produktów.",
                            success: false
                        });
                    }
                } catch (error) {
                    console.log(error);
                    this.$store.commit('setNotification', {
                        show: true,
                        head: "Błąd podczas wyszukiwania zepsutych parts!",
                        subheader: error.message || error,
                        success: false
                    });
                } finally {
                    this.loading = false;
                }
            },
            async repairBrokenVariantPart(row, options = {}) {
                if (!row || !row.repairable || row.updating || row.updated) return;

                row.updating = true;
                row.error = null;

                try {
                    const productDocId = row.productDocId || row.productId;
                    const variantKey = row.variantKey || row.variantId;
                    if (!productDocId || !variantKey) throw new Error('Brak productDocId lub variantKey.');

                    const productRef = db.collection('Products').doc(productDocId);
                    const productSnapshot = await productRef.get();
                    if (!productSnapshot.exists) throw new Error(`Produkt ${productDocId} nie istnieje.`);

                    const product = productSnapshot.data() || {};
                    const variant = product.variants?.[variantKey];
                    if (!variant || typeof variant !== 'object') throw new Error(`Wariant ${variantKey} nie istnieje.`);

                    const currentParts = variant.parts;

                    if (row.repairType === 'emptyPartsObject') {
                        if (currentParts && typeof currentParts === 'object' && !Array.isArray(currentParts) && Object.keys(currentParts).length === 0) {
                            await productRef.update({
                                [`variants.${variantKey}.parts`]: null,
                            });
                        }
                    } else if (row.repairType === 'invalidPartKey') {
                        if (!currentParts || typeof currentParts !== 'object' || Array.isArray(currentParts)) {
                            throw new Error('Aktualne parts nie jest obiektem.');
                        }

                        const cleanedParts = { ...currentParts };
                        const keyToRemove = row.partKey === '---' ? '' : row.partKey;
                        delete cleanedParts[keyToRemove];

                        await productRef.update({
                            [`variants.${variantKey}.parts`]: Object.keys(cleanedParts).length > 0 ? cleanedParts : null,
                        });
                    } else {
                        throw new Error('Ten typ problemu jest tylko raportowany.');
                    }

                    row.updated = true;
                    if (!options.silent) {
                        this.$store.commit('setNotification', {
                            show: true,
                            head: "Naprawiono parts wariantu.",
                            subheader: `${row.productName || row.productId} / ${row.variantName || row.variantId}`,
                            success: true
                        });
                    }
                } catch (error) {
                    row.error = error.message || error;
                    if (!options.silent) {
                        this.$store.commit('setNotification', {
                            show: true,
                            head: "Nie udało się naprawić parts wariantu.",
                            subheader: error.message || error,
                            success: false
                        });
                    }
                } finally {
                    row.updating = false;
                }
            },
            async repairAllBrokenVariantParts() {
                if (this.repairingBrokenVariantParts) return;

                const rowsToRepair = this.brokenVariantPartsTable.filter((row) => row.repairable && !row.updated && !row.updating);
                if (rowsToRepair.length === 0) return;

                this.repairingBrokenVariantParts = true;
                let repaired = 0;
                let failed = 0;

                try {
                    for (const row of rowsToRepair) {
                        await this.repairBrokenVariantPart(row, { silent: true });
                        if (row.updated) {
                            repaired++;
                        } else {
                            failed++;
                        }
                    }

                    this.$store.commit('setNotification', {
                        show: true,
                        head: "Zakończono masową naprawę parts.",
                        subheader: `Naprawiono: ${repaired}, błędy: ${failed}.`,
                        success: failed === 0
                    });
                } catch (error) {
                    this.$store.commit('setNotification', {
                        show: true,
                        head: "Błąd podczas masowej naprawy parts.",
                        subheader: error.message || error,
                        success: false
                    });
                } finally {
                    this.repairingBrokenVariantParts = false;
                }
            },
            async updateAllPartsNames() {
                if (!this.productsWithSpacesTable || this.productsWithSpacesTable.length === 0) return;
                for (let i = 0; i < this.productsWithSpacesTable.length; i++) {
                    const row = this.productsWithSpacesTable[i];
                    // Pomijaj już zaktualizowane lub aktualizowane
                    if (row.updated || row.updating) continue;
                    await this.updatePartName(row);
                }
            },
            async fixBrokenPackage(row) {
                console.log('test');
                row.updating = true;
                row.error = null;
                console.log(row);
                try {
                    await this.updatePackageName(
                        row.storageId,
                        row.segmentId,
                        row.productId,
                        row.variantId,
                        row.oldPackageName,
                        row.newPackageName
                    );
                    row.updated = true;
                } catch (e) {
                    row.error = e.message || e;
                }
                row.updating = false;
            },

            async updatePackageName(storageId, segmentId, productId, variantId, oldPackageName, newPackageName) {
                try {
                    // Wywołanie funkcji chmurowej (Cloud Function) do aktualizacji nazwy paczki
                    // Wyciągnij productId z variantId (np. v_XgErQW16Tej0v3ja_p_z0372nowOmm0W5Kt1qhz_NAZWA)
                    
                    console.log('test');
                    let extractedProductId = '';
                    const match = variantId.match(/_p_([^_]+)/);
                    if (match && match[1]) {
                        extractedProductId = match[1];
                    } else {
                        extractedProductId = productId; // fallback jeśli nie znajdzie
                    }

                    const res = await axios.post(`${this.$store.state.apiLink}/updatePackageName`, {
                        storageId,
                        segmentId,
                        productId: extractedProductId,
                        variantId,
                        oldPackageName,
                        newPackageName
                    });

                    if (res.data && res.data.success) {
                        this.$store.commit('setNotification', {
                            show: true,
                            head: "Zaktualizowano nazwę paczki!",
                            subheader: `Nowa nazwa: ${newPackageName}`,
                            success: true
                        });
                    } else {
                        throw new Error(res.data && res.data.message ? res.data.message : 'Błąd podczas aktualizacji paczki!');
                    }
                } catch (error) {
                    console.log(error);
                    this.$store.commit('setNotification', {
                        show: true,
                        head: "Błąd podczas aktualizacji paczki!",
                        subheader: error.message || error,
                        success: false
                    });
                }
            },
            generateCustomIds(prod)
            {
                const prodVariants = Object.values(prod.variants);
                for(let i=0; i<prodVariants.length; i++)
                {
                    console.log(i);
                    for(let y=0; y<prodVariants[i].amountOfPackages; y++)
                    {
                        console.log(prodVariants[i].id + '_' + (y+1) + '-' + randomstring.generate(15));
                    }
                }
            },
            // uncomment when needed to repair products /w segments
            // async repairProductsBySegments()
            // {
            //     try {
            //         // const res = await axios.post(`${this.$store.state.apiLink}/order/repairBySegments`, {})
            //         let segments = [];
            //         const getStorage = await db.collection('Storage').get();
            //         for(let i=0; i<getStorage.docs.length; i++)
            //         {
            //             let current = getStorage.docs[i].data();
            //             const getSegments = await db.collection('Storage').doc(current.id.toString()).collection('Segments').get();
            //             for(let y=0; y<getSegments.docs.length; y++)
            //             {
            //                 let crnt = getSegments.docs[y].data();
            //                 crnt.warehouse = current;
            //                 if(Object.keys(crnt.products).length > 0)
            //                 {
            //                     segments.push(crnt)
            //                 }
            //             }
            //         }

            //         const getProducts = await db.collection('Products').get();
    
            //         if(segments.length === 0) throw 'BRAK SEGMENTÓW.'
            //         //check storage for broken quantity
                
            //         for(let i=0; i<getProducts.docs.length; i++)
            //         {
            //             console.log('product: ' + (i+1) + ' / ' + getProducts.docs.length + ' - ' + getProducts.docs[i].id);
            //             let current = getProducts.docs[i].data();
            //             let prodRef = db.collection('Products').doc(getProducts.docs[i].id);
            //             if(current.variants != null)
            //             {
            //                 const variants = Object.entries(current.variants);
            //                 for(let y=0; y<variants.length; y++)
            //                 {
            //                     console.log('variant: ' + (y+1) + ' / ' + variants.length + ' - ' + variants[y][0]);
            //                     if(variants[y][1] != null)
            //                     {
            //                         if(variants[y][1].parts != null)
            //                         {
            //                             const partsToCheck = Object.entries(variants[y][1].parts);
            //                             for(let i=0; i<partsToCheck.length; i++)
            //                             {
            //                                 partsToCheck[i][1].quantity = 0;
            //                                 let partFound = false;
            //                                 for(let s=0; s<segments.length; s++)
            //                                 {
            //                                     if(partFound) break;
            //                                     if(segments[s].products[current.id] != null)
            //                                     {
            //                                         // console.log(segments[y].products[current.id]);
            //                                         const addedToSegment = Object.entries(segments[s].products[current.id])
            //                                         for(let a=0; a<addedToSegment.length; a++)
            //                                         {
            //                                             if(addedToSegment[a][0].includes(variants[y][0]))
            //                                             {
            //                                                 let str = addedToSegment[a][0];
            //                                                 let num = str.lastIndexOf('_');
            //                                                 let res = str.substring(num+1);
            //                                                 if(partsToCheck[i][1].name === res)
            //                                                 {
            //                                                     partsToCheck[i][1].quantity += addedToSegment[a][1].quantity;
            //                                                     if(addedToSegment[a][1].order != null && addedToSegment[a][1].order.length > 0)
            //                                                     {
            //                                                         partsToCheck[i][1].quantity -= addedToSegment[a][1].order.length;
            //                                                     }
            //                                                 }
            //                                             }
            //                                         }
            //                                     }
            //                                 }
            //                                 console.log(`[variants.${variants[y][0]}.parts.${partsToCheck[i][0]}.quantity:]`+ partsToCheck[i][1].quantity);
            //                                 await prodRef.update({
            //                                     [`variants.${variants[y][0]}.parts.${partsToCheck[i][0]}.quantity`]: partsToCheck[i][1].quantity,
            //                                 });

            //                             }
            //                             // tutaj
            //                             let totalPartsAmount = 0;
            //                             let productEntries = partsToCheck;
            //                             let numberToCheck = null;
            //                             let lowestNumber = null;
            //                             if(productEntries.length === variants[y][1].amountOfPackages)
            //                             {
            //                                 let everythingSame = true;
            //                                 for(let i=0; i<productEntries.length; i++)
            //                                 {
            //                                     if(productEntries[i][1].quantity < lowestNumber || lowestNumber === null)
            //                                     {
            //                                         lowestNumber = productEntries[i][1].quantity;
            //                                     }
            //                                     if(numberToCheck === null)
            //                                     {
            //                                         numberToCheck = productEntries[i][1].quantity;
            //                                     }
            //                                     if(numberToCheck !== productEntries[i][1].quantity)
            //                                     {
            //                                         everythingSame = false;
            //                                     }
            //                                 }
            //                                 if(everythingSame)
            //                                 {
            //                                     totalPartsAmount = numberToCheck;
            //                                     await prodRef.update({
            //                                         [`variants.${variants[y][0]}.quantity`]: totalPartsAmount,
            //                                     });
            //                                 }
            //                                 else
            //                                 {
            //                                     totalPartsAmount = lowestNumber;
            //                                     await prodRef.update({
            //                                         [`variants.${variants[y][0]}.quantity`]: totalPartsAmount,
            //                                     });
            //                                 }
            //                             }
            //                         }
            //                     }
            //                 }
            //             }
            //         }
            //     }
            //     catch (error) {
            //         console.log(error);    
            //     }
            // },
            // async repairNulls()
            // {
            //     try {
            //         console.log('start function');
            //         const getProducts = await db.collection('Products').get();
            //         for(let i=0; i<getProducts.docs.length; i++)
            //         {
            //             let product = getProducts.docs[i].data();
            //             let variants = Object.values(product.variants);
            //             for(let y=0; y<variants.length; y++)
            //             {
            //                 if(variants[y].parts != null)
            //                 {
            //                     let parts = Object.entries(variants[y].parts);
            //                     for(let p=0; p<parts.length; p++)
            //                     {
            //                         if(parts[p][0] === null || parts[p][0] == 'null')
            //                         {
            //                             console.log(product.id + ' - ' + variants[y].id + ' - ' + parts[p][0]);
            //                         }
            //                     }
            //                 }
            //             }
            //         }
            //         console.log('end function');
            //     } catch (error)
            //     {
            //         console.log(error);    
            //     }
            // },
            resetSearch()
            {
                this.products = [];
                this.searcher.found = [];
                this.searcher.lastCall = null;
                this.searcher.phrase = "";
                this.dbListener = db.collection("Products").orderBy("meta.createdDate", "desc").limit(this.queryLimit)
                .onSnapshot((querySnapshot) => {
                    this.queryLoading = true;
                    this.products = [];
                    if(querySnapshot.docs.length<this.queryLimit)
                    {
                        this.queryLimitReached = true;
                    }
                    else
                    {
                        this.queryLimitReached = false;
                    }
                    querySnapshot.forEach((doc) => {
                        this.products.push(doc.data())
                        this.lastLoaded = doc.data().meta.createdDate;
                        
                    });
                    this.queryLoading = false;
                });
            },
            async search()
            {
                if(this.searcher.phrase.length > 0)
                {
                    this.searcher.locked = true;
                    const res = await axios.post(`${this.$store.state.apiLink}/search`, {
                        index: "jan-art-products",
                        collection: "Products",
                        phrase: this.searcher.phrase,
                        searchFields: ['names','models','skus','eans','id','categories','manufacturers','variantsIds','baselinkerIds']

                    })
                    if(res.data.success)
                    {
                        this.searcher.found = res.data.found;
                        if(res.data.found.length > 0)
                        {
                            this.searcher.lastCall = res.data.data;
                            // this.dbListener();
                            this.$store.commit('setNotification',{
                                show: true,
                                head: "Wyszukiwanie zakończone!",
                                subheader: `Znaleziono ${res.data.found.length} produktów.`,
                                success: true
                            });

                        }else{
                            this.$store.commit('setNotification',{
                                show: true,
                                head: "Nie znaleziono wyników!",
                                subheader: `Spróbuj wyszukać inną frazę.`,
                                success: false
                            });
                        }

                    }
                    else
                    {
                        this.$store.commit('setNotification',{
                            show: true,
                            head: "Wyszukiwanie zakończone niepowodzeniem!",
                            subheader: `Coś poszło nie tak...`,
                            success: false
                        });
                    }
                    setTimeout(()=>
                    {
                        // this.searcher.phrase = "";
                        this.searcher.locked = false;
                    }, 3000)
                }
                else
                {
                    return;
                }
            },
            loadMoreProducts() {
                this.queryLimit = this.queryLimit + 10;
                this.getProducts()
            },
            closeModal()
            {
                this.modal = {
                    open: false,
                    product: null
                }
            },
            closeVariantsModal()
            {
                this.variantsModal = {
                    open: false,
                    product: null
                }
            },
            showModal(product)
            {
                this.modal = {
                    open: true,
                    product: product
                }
            },
            showVariantsModal(product)
            {
                this.variantsModal = {
                    open: true,
                    product: product
                }
            },
            copyToClipboard(id)
            {
                navigator.clipboard.writeText(id).then(()=>
                {
                    this.$store.commit('setNotification',{
                        show: true,
                        head: "Skopiowano do schowka!",
                        subheader: ``,
                        success: true
                    }); 
                })

            },
            async getProducts() {
                this.products = []
                const { docs } = await db.collection("Products").orderBy("meta.createdDate", "desc").limit(this.queryLimit).get()
                for(let doc of docs) {
                    this.products.push(doc.data())
                }
                // console.log(this.products);
            },
        },
    }
</script>
<style lang="scss" scoped>
    .fade-enter-active,
    .fade-leave-active {
    transition: opacity 0.5s ease;
    }

    .fade-enter-from,
    .fade-leave-to {
    opacity: 0;
    }
</style>
